// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3H3qC","content":"PrivacyPolicyPage_content__2-KDW"};